import { render, staticRenderFns } from "./DataTime.vue?vue&type=template&id=f56e5188&scoped=true"
import script from "./DataTime.vue?vue&type=script&lang=js"
export * from "./DataTime.vue?vue&type=script&lang=js"
import style0 from "./DataTime.vue?vue&type=style&index=0&id=f56e5188&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56e5188",
  null
  
)

export default component.exports